import {solution} from '../lib/words'

export const MAX_WORD_LENGTH = solution.length
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2500
export const REVEAL_TIME_MS = 300
export const GAME_LOST_INFO_DELAY = (MAX_WORD_LENGTH + 1) * REVEAL_TIME_MS
export const WELCOME_INFO_MODAL_MS = 350
export const CONFETTI_REVEAL_TIME_MS = 2500
export const CONFETTI_DISABLE_TIME_MS = 12000
